<template>
  <v-dialog width="400" v-model="showDialog">
    <v-card>
      <v-card-title class="secondary white--text">
        <span>Change Invoice Date & Remarks</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="invoiceDateForm" v-model="isValid">
          <v-row>
            <v-col cols="12" class="Form-Columns-Dense">
              <DateField
                :inputProps="{
                  dense: true,
                  label: 'Invoice Date *',
                  rules: [(val) => !!val || 'Invoice Date is required!'],
                  'hide-details': 'auto',
                  'error-messages': formErrors.invoice_date,
                }"
                required
                v-model="invoice_date"
                @input="delete formErrors.invoice_date"
              />
            </v-col>
            <v-col cols="12" class="Form-Columns-Dense">
              <InputField
                dense
                label="Remarks"
                hide-details="auto"
                type="text"
                :clearable="true"
                v-model="remarks"
                :error-messages="formErrors.remarks"
                @input="delete formErrors.remarks"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Update
        </v-btn>
        <v-btn class="ml-3" color="secondary" depressed @click="showDialog = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateField from "@/components/FormBaseComponents/DateField.vue";
import InputField from "@/components/FormBaseComponents/InputField.vue";

export default {
  components: { DateField, InputField },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    invoiceId: {
      type: [Number, null],
      default: null,
    },
    currentDate: {
      type: String,
      default: null,
    },
    currentRemarks: {
      type: String,
      default: null,
    },
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.invoice_date = this.currentDate;
        this.remarks = this.currentRemarks;
      } else {
        this.resetForm();
      }
    },
  },

  data() {
    return {
      isValid: true,
      invoice_date: null,
      remarks: null,
      formErrors: {},
    };
  },

  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      this.$api.customerInvoice
        .updateInvoiceDate(this.invoiceId, {
          invoice_date: this.invoice_date,
          remarks: this.remarks,
        })
        .then(() => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Invoice updated successfully!",
            color: "success",
          });
          this.$emit("refreshDetails");
          this.showDialog = false;
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message:
              err?.data?.non_field_errors?.join() || "Couldn't update invoice",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },

    resetForm() {
      if (this.$refs.invoiceDateForm) {
        this.$refs.invoiceDateForm.reset();
      }
      this.invoice_date = null;
      this.remarks = null;
      this.formErrors = {};
    },
  },
};
</script>